<div id="paginaResultadosBusca" class="paginaResultadosBusca">
  <mat-progress-bar
    mode="indeterminate"
    *ngIf="carregando"
    class="mat-progress-bar-busca-avancada"
  ></mat-progress-bar>

  <div
    class="paginador-placeholder"
    [ngStyle]="{ visibility: !carregando ? 'visible' : 'hidden' }"
  >
    <app-paginador
      [paginas]="paginas"
      [indexAtual]="indexPaginaAtual"
      [textoCentralPaginador]="textoBotaoPaginador"
      (retroceder)="btnLeftClick()"
      (avancar)="btnRightClick()"
      (irPara)="alterarPagina($event)"
    >
    </app-paginador>
  </div>

  <ng-container *ngIf="!carregando; else elseCarregando">
    <div class="viewport">
      <div *uiScroll="let item of datasource">
        <div [ngSwitch]="instanceofClass(item)">
          <div *ngSwitchCase="'CabecalhoGrupoBusca'">
            <div class="flex-row center-center cabecalho-resultado">
              <span class="span-caminho-resultado">
                <span
                  class="item-breadcrumb"
                  *ngFor="let item of item.breadcrumb"
                  >{{ item }}</span
                >
              </span>
              <span class="flex-1"></span>
              <span
                (click)="
                  abrirEmNovaGuia(paginas[indexPaginaAtual], item.idNavegar)
                "
              >
                <img
                  class="img-abrir-guia"
                  src="assets/ui/icons/ic-abrir-nova-guia.png"
                  title="Abrir em nova guia"
                />
              </span>
            </div>
          </div>
          <div *ngSwitchCase="'TextoPagina'">
            <div *ngIf="instanceofClass(item) === 'TextoPagina'">
              <app-marcacao-superior
                [opcoesPonteiros]="opcoesCoresPonteiros"
                [posicaoAtual]="'Acima'"
                [setLinha]="item"
              >
              </app-marcacao-superior>
              <app-linha [id]="'linha' + item.id" [linha]="item"></app-linha>
              <app-marcacao-superior
                [opcoesPonteiros]="opcoesCoresPonteiros"
                [posicaoAtual]="'Abaixo'"
                [setLinha]="item"
              >
              </app-marcacao-superior>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #elseCarregando>
  <div class="viewport"></div>
</ng-template>
